import React, { useState } from 'react';
import {
    Grid,
    IconButton,
    Tooltip,
    Menu,
    Divider,
    Typography,
} from '@material-ui/core';
import { defaultStyles } from 'utils/Theme';
import * as Icon from '@material-ui/icons';
import PropTypes from 'prop-types';

const PageDropdown = ({ title, description, id }) => {
    const [anchorEl, setAnchorEl] = useState(null);
    const classes = defaultStyles();

    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };

    return (
        <>
            <IconButton
                aria-controls="page-description"
                onClick={handleClick}
                aria-haspopup="true"
            >
                <Tooltip title={'Page Info'} arrow>
                    <Icon.InfoOutlined className={classes.colorPrimary} />
                </Tooltip>
            </IconButton>

            <Menu
                id="page-description"
                anchorEl={anchorEl}
                keepMounted
                open={Boolean(anchorEl)}
                onClose={handleClose}
                PaperProps={{
                    style: { borderRadius: 20 },
                }}
            >
                <Grid
                    container
                    style={{ width: 250, padding: 16 }}
                    direction="column"
                    justifyContent="flex-start"
                >
                    <Grid item>
                        <Typography variant="h6">{title}</Typography>
                    </Grid>
                    {description && (
                        <Grid item>
                            <p>{description}</p>
                        </Grid>
                    )}

                    {id && (
                        <>
                            <Divider
                                variant="fullWidth"
                                style={{ marginTop: 10 }}
                            />

                            <Grid item>
                                <Typography variant="overline">
                                    Qlik App Id
                                </Typography>
                                <p> {id}</p>
                            </Grid>
                        </>
                    )}
                </Grid>
            </Menu>
        </>
    );
};

PageDropdown.propTypes = {
    title: PropTypes.string.isRequired,
    description: PropTypes.string,
    id: PropTypes.string,
};

PageDropdown.defaultProps = {
    description: null,
    id: null,
};

export default PageDropdown;
